import { create } from 'zustand';
import { PaginationState } from './type';
import { InquiryStatus } from '@/types/response/inquiry';

type InquiryFilter = PaginationState & {
  search?: string;
  status?: InquiryStatus;
};

type InquiryState = {
  filter: InquiryFilter;
  id?: number | null;
  openDetail: boolean;
};

type InquiryAction = {
  setParams: (params: Partial<InquiryFilter>) => void;
  setInquiryId: (id: number) => void;
  onOpenDetail: (id?: number | null) => void;
  onCloseDetail: () => void;
};

export type InquiryStore = InquiryState & InquiryAction;

export const useInquiryStore = create<InquiryStore>()((set, get) => ({
  filter: {
    search: '',
    page: 1,
    limit: 10,
  },
  openDetail: false,
  setParams: (params) => set({ filter: { ...get().filter, ...params } }),
  setInquiryId: (id) => set({ id }),
  onOpenDetail: (id) => set({ id, openDetail: true }),
  onCloseDetail: () => set({ id: null, openDetail: false }),
}));
